module.exports = __webpack_public_path__ + "../assets/cisco-and-cob.png";